import { component } from 'picoapp'
import $ from 'quantdom'
import { centsToDollars, getProduct, compareArrays } from '../lib/utils'

function updateOptions(variants, selectedVariant, forms) {
  forms.forEach((el, index) => {
    const availableVariants = variants
      .filter((variant) => {
        return compareArrays(
          variant.options.filter((op, i) => i != index),
          selectedVariant.options.filter((op, i) => i != index)
        )
      })
      .filter((variant) => variant.available)
    const availableOptions = availableVariants.map((variant) => variant[`option${index + 1}`])
    el.querySelectorAll('input[type="radio"]').forEach((item) => {
      $(item).el().checked = selectedVariant[`option${index + 1}`] === item.value
      if (availableOptions.includes(item.value)) {
        $(item.nextElementSibling).removeClass('slashed-selector')
        $(item.nextElementSibling).removeClass('peer-checked:slashed-selector-active')
      } else {
        $(item.nextElementSibling).addClass('slashed-selector')
        $(item.nextElementSibling).addClass('peer-checked:slashed-selector-active')
      }
    })
  })
}

function firstAvailableVariant(product = {}, options = [], prioritizedOptionPosition = 1) {
  const variants = product.variants
  return variants
    .filter((variant) => variant[`option${prioritizedOptionPosition}`] === options[prioritizedOptionPosition - 1])
    .sort((a, b) => {
      if (a.available === b.available) {
        return product.options[0].values.indexOf(a.option1) - product.options[0].values.indexOf(b.option1)
      } else {
        return a.available < b.available ? 1 : -1
      }
    })[0]
}

export default component(async (node) => {
  const handle = $(node).attr('data-handle')
  const productData = getProduct(handle)
  const product = await productData
  const variants = product.variants
  const addButton = $(`add-button[data-product-id="${product.id}"]`)
  const url = new URL(window.location)
  const isProductPage = url.pathname.includes(product.url)
  let location = $(node).attr('data-location') || null
  let selectedVariant = null
  let initialized = false

  async function optionsHandler(e) {
    let options = []
    const forms = $(node).find('.js-option-form').els
    forms.forEach((el) => {
      const value = el.querySelector('input[type="radio"]:checked').value
      options.push(value)
    })
    selectedVariant =
      variants.find((variant) => compareArrays(variant.options, options)) ||
      firstAvailableVariant(product, options, parseInt(e?.target.closest('form').dataset.position))

    //update the options
    updateOptions(variants, selectedVariant, forms)

    addButton.attr('data-variant-id', selectedVariant.id)

    if (selectedVariant.available === false) {
      addButton.attr('data-sold-out', 'true')
      addButton.attr('aria-disabled', 'true')
    } else {
      addButton.attr('data-sold-out', 'false')
      addButton.attr('aria-disabled', 'false')
    }

    if (isProductPage || location === 'buybox') {
      location = 'buybox'
      //sets the current option value
      if (document.querySelector('.js-current-option-value') !== null) {
        product.options.forEach((option) => {
          $(`.js-option-form[data-position="${option.position}"]`)
            .find('.js-current-option-value')
            .text(selectedVariant.options[option.position - 1])
        })
      }

      if (isProductPage) {
        url.searchParams.set('variant', selectedVariant.id)
        history.replaceState({}, '', url)
      }

      //only update add button variant id and update prices with upsell variant if upsell kit is checked
      const pdpUpsellKit = $('.js-pdp-upsell-kit').el()
      if (pdpUpsellKit && pdpUpsellKit?.checked) {
        const upsell_variant = getUpsellVariant(selectedVariant.id) ?? selectedVariant
        addButton.attr('data-variant-id', upsell_variant.id)
        updatePrices(`.js-pdp-main[data-product-id="${product.id}"]`, upsell_variant)
      } else if (initialized) {
        addButton.attr('data-variant-id', selectedVariant.id)
        updatePrices(`.js-pdp-main[data-product-id="${product.id}"]`, selectedVariant)
      }
    } else if (initialized) {
      updatePrices(`.js-product-card[data-product-id="${product.id}"]`, selectedVariant)
    }

    if (initialized) {
      window.MicroBus.emit('variant:change', {
        variant_id: selectedVariant.id,
        variant: selectedVariant,
        product: product,
        location: location,
      })

      if (window?.gtag) {
        window.gtag('event', 'Variant Selection', {
          event_detail: selectedVariant.id,
          event_detail2: options[0],
        })
      }
    }
    initialized = true
  }

  $(node).find('.js-option-form').on('change', optionsHandler)
  optionsHandler()

  if ($('.js-pdp-upsell-kit').el() && window?._upsell_kit) {
    $('.js-pdp-upsell-kit').on('change', (e) => {
      const checked = e.target.checked
      const upsell_variant = getUpsellVariant(selectedVariant.id)
      if (checked) {
        addButton.attr('data-variant-id', upsell_variant.id)
        updatePrices(`.js-pdp-main[data-product-id="${product.id}"]`, upsell_variant)
      } else {
        addButton.attr('data-variant-id', selectedVariant.id)
        updatePrices(`.js-pdp-main[data-product-id="${product.id}"]`, selectedVariant)
      }

      if (window?.gtag) {
        window.gtag('event', 'Kit Toggle', {
          event_detail: e.target.checked ? 'Toggle On' : 'Toggle Off',
          event_detail2: upsell_variant.name,
        })
      }
    })
  }

  $('add-button.js-sticky-add-button').on('click', (e) => {
    const productTitle = $('add-button.js-sticky-add-button').attr('data-product-title')
    if (window?.gtag) {
      window.gtag('event', 'Sticky Add to Cart', {
        event_detail: productTitle,
      })
    }
  })

  $('accordion-item').on('click', (e) => {
    const title = $(e.target).el().innerText
    if (window?.gtag) {
      window.gtag('event', ' Dropdown Menu', {
        event_detail: title,
      })
    }
  })

  $('side-drawer-btn[for="pdp-money-back-learn-more"]').on('click', (e) => {
    if (window?.gtag) {
      window.gtag('event', 'Guarantee Click', {})
    }
  })
})
function updatePrices(el, selectedVariant) {
  $(el)
    .find('.js-price')
    .text('$' + centsToDollars(selectedVariant.price))
  $(el)
    .find('.js-split-price')
    .text('$' + centsToDollars(selectedVariant.price / 4))
  if (selectedVariant.compare_at_price > selectedVariant.price) {
    $(el)
      .find('.js-compare-price')
      .text('$' + centsToDollars(selectedVariant.compare_at_price))
    $(el)
      .find('.js-price-savings')
      .text('$' + centsToDollars(selectedVariant.compare_at_price - selectedVariant.price))
    $(el).find('.js-compare-price').show(true)
    $(el).find('.js-price-savings-wrapper').show(true)
  } else {
    $(el).find('.js-compare-price').hide(true)
    $(el).find('.js-price-savings-wrapper').hide(true)
  }
}

function getUpsellVariant(selectedVariantId) {
  if (window?._upsell_kit) {
    const { original_variants, upsell_variants } = window._upsell_kit
    const index = original_variants.findIndex((v) => v.id === selectedVariantId)
    return upsell_variants[index]
  } else {
    return null
  }
}
